// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"1e4e2ada","302":"497fd54f","342":"48667fbc","382":"a165df02","474":"1baf4c02","547":"4cd13918","626":"a1877261","958":"e21e6ab5"}[chunkId] + ".chunk.js";
};